import { OrganizationRole } from '@/entities/session';

export const ROLES_LABELS: Record<OrganizationRole, string> = {
  [OrganizationRole.ADMIN]: 'Admin',
  [OrganizationRole.USER]: 'User',
};
